import React from 'react';
import BuildIcon from '@mui/icons-material/Build';
import LanguageIcon from '@mui/icons-material/Language';
import { FieldsTopLabelProps } from './FieldsSettingsTypes';
import { styled } from '@mui/material/styles';

const StyledIcon = styled('span')(({ theme }) => ({
  color: '#505050',
  position: 'relative',
  top: '5px',
  marginRight: theme.spacing(1),
  display: 'inline-flex',
  alignItems: 'center',
}));

const LabelText = styled('span')({
  verticalAlign: 'middle',
});

const FieldsTopLabel = ({ trainingSetDataTypeIsGlobal }: FieldsTopLabelProps): JSX.Element => {
  return (
    <>
      {trainingSetDataTypeIsGlobal ? (
        <LabelText>
          <StyledIcon>
            <LanguageIcon />
          </StyledIcon>
          This Field-list uses Global Format Settings. Click on FORMATS button to view the format
          settings.
        </LabelText>
      ) : (
        <LabelText>
          <StyledIcon>
            <BuildIcon />
          </StyledIcon>
          This Field-list uses one or more custom format settings. Scroll down to the fields to view
          the format settings.
        </LabelText>
      )}
    </>
  );
};

export default FieldsTopLabel;
